import React, { useState, useEffect } from 'react';
import { format, startOfMonth, endOfMonth, eachDayOfInterval, startOfWeek, endOfWeek, isToday, isSameDay, isSameMonth, getDate } from 'date-fns';
import { db } from "../firebase/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { Link } from 'react-router-dom';
import Cancelled from "../resources/cancelled.png";

const EventsCalendar = () => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const startDate = startOfMonth(currentMonth);
  const endDate = endOfMonth(currentMonth);
  const days = eachDayOfInterval({ start: startOfWeek(startDate), end: endOfWeek(endDate) });

  const handlePreviousMonth = () => {
    setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));
  };

  const timestampToDate = (timestamp) => {
    const seconds = timestamp.seconds;
    const nanoseconds = timestamp.nanoseconds;
    return new Date(seconds * 1000 + nanoseconds / 1000000);
  };
  
  const formatDateTime = (date) => {
    return format(date, 'h:mm a'); 
  };

  const formatDateDate = (date) => {
    return format(date, 'd MMMM'); 
  };

  const [eventsData, setEventsData] = useState([]);
  
  useEffect(() => {
      document.getElementsByClassName('events-show')[0].style.display = "none";

      const fetchEventsData = async () => {
          try {
          const querySnapshot = await getDocs(collection(db, "Events Calendar"));
          const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          
          for (let key in documents) {
            if (documents.hasOwnProperty(key)) {
              documents[key].StartDateTime = timestampToDate(documents[key].StartDateTime); 
              documents[key].EndDateTime = timestampToDate(documents[key].EndDateTime); 
            }
          }

          setEventsData(documents);
          } catch (error) {
          console.error("Error fetching data: ", error);
          }
      };
  
      fetchEventsData();
  }, []);

  const [eventsShow, setEventsShow] = useState({"StartDateTime":0, "EndDateTime":0});

  const eventHover = async (e) => {
    const eventName = e.currentTarget.getElementsByClassName("event-title")[0].innerHTML;

    for (let key in eventsData) {
      if (eventsData[key].Title === eventName) {
        setEventsShow(eventsData[key]);

        const rect = e.target.parentNode.parentNode.parentNode.parentNode.getBoundingClientRect();
        const position = {
            top: rect.top,
            left: rect.left,
            bottom: rect.bottom,
            right: rect.right,
            width: rect.width,
            height: rect.height
        };
  
        document.getElementsByClassName('events-show')[0].style.top = `${position.top - position.height}px`;
        document.getElementsByClassName('events-show')[0].style.left = `${position.left - position.width}px`;
        document.getElementsByClassName('events-show')[0].style.display = "block";
      }
    }
  }

  const eventBlockHover = () => {
    document.getElementsByClassName('events-show')[0].style.display = "block";
  }

  const eventLeaveHover = () => {
    document.getElementsByClassName('events-show')[0].style.display = "none";
  }

  return (
    <div id='content'>
      <div className='row'>
        <div className='col-sm-6'>
          <h1>{format(currentMonth, 'MMMM yyyy')}</h1>
          <h2 className='ev-sub-title'>Revival Church Montana</h2>
        </div>
        <div className='col-sm-6 calendar-buttons'>
          <div className='event-button'>
            <Link to="/add-event"><button>Add Event</button></Link>
          </div>
          <div className='navigate-buttons'>
              <button onClick={handlePreviousMonth}>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"/></svg>
            </button>
            <button onClick={handleNextMonth}>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"/></svg>
            </button>
          </div>
        </div>
      </div>
      <br/>
      <div className='calendar'>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', textAlign: 'center' }}>
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
            <div key={day}>{day}</div>
          ))}

            {days.map(day => {
              const dayEvents = eventsData.filter(event => {
              const isSingleDayEvent = isSameDay(day, event.StartDateTime);
              
              const eventDay = format(new Date(event.StartDateTime), 'EEEE');
              const currentDay = format(day, 'EEEE');
              const isWithinDateRange = day >= new Date(event.StartDateTime) && day <= new Date(event.EndDateTime);
              const isRecurringWeek = event.Repeat === 'Repeat Every Week' && eventDay === currentDay && isWithinDateRange;
              const isRecurringDay = event.Repeat === 'Repeat Every Day' && isWithinDateRange;
              
              return isSingleDayEvent || isRecurringWeek || isRecurringDay;
            });

            const isCurrentMonth = isSameMonth(day, currentMonth);

            return (
              <div
              className='event-block'
                key={day}
                style={{
                  padding: '10px',
                  backgroundColor: isToday(day) ? 'lightblue' : 'white',
                  color: isCurrentMonth ? 'black' : 'lightgray',
                  border: '1px solid #ddd',
                  position: 'relative',
                  cursor: 'pointer'
                }}
              >
                {format(day, 'd')}
                {dayEvents.map(event => (
                <div className='day-events'
                style={{
                  backgroundColor: isCurrentMonth ? '#d170d16b' : '#dddddd6b',
                }}>
                  <div key={event.Title} onMouseOver={(e) => eventHover(e)} onMouseLeave={(e) => eventLeaveHover(e)}>
                    <p style={{display: 'flex', alignItems: 'center', marginBottom: '0px'}}>
                      <span className='event-time'
                style={{
                  borderRight: isCurrentMonth ? '1px solid #d170d1cb' : '1px solid #ddddddcb'
                }}>{formatDateTime(event.StartDateTime)}</span> 
                      <span className='event-title'>{event.Title}</span>
                    </p>
                  </div>
                </div>
                ))}
              </div>
            );
          })}
        </div>
      <Link to={`/edit-event/${encodeURIComponent(eventsShow.Title)}`}>
      <div className='events-show' onMouseOver={(e) => eventBlockHover(e)} onMouseLeave={(e) => eventLeaveHover(e)}>
        {eventsShow.Cancelled ? <img id='event-cancelled' src={Cancelled} width="100%" /> : <></>}
        <img src={eventsShow.FeaturedImage} width="100%" />
        <p className='ev-show-title'>{eventsShow.Title}</p>
        <p className='ev-show-dates'>{formatDateDate(eventsShow.StartDateTime)} - {formatDateDate(eventsShow.EndDateTime)}</p>
      </div>
      </Link>
      </div>
    </div>
  );
}

export default EventsCalendar;
